import InfoLight from '../../../../../assets/svgs/InfoLight'
import MetaLogo from '../../../../../assets/svgs/MetaLogo'
import PinLightIcon from '../../../../../assets/svgs/PinLight'
import style from './style.module.css'
import CompanyBackground from '../../../../../assets/images/CompanyModalBackground.jpg'
import EventsBlock from './components/EventsBlock'
import NewsBlock from './components/NewsBlock'
import PositionBlock from './components/PositionsBlock'
import StatsBlock from './components/StatsBlock'
import AddToChatBlock from './components/AddToChatBlock'
import useWindowWidth from '../../../../../hooks/useWindowWidth'
import CrossSpotlightIcon from '../../../../../assets/svgs/CrossSpotlight'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/pagination'

import './style.css'

const CompanyModal = ({ data, handleCompanyOpen }) => {
  const isMobile = useWindowWidth() <= 768

  return (
    <div className={style.companyModal}>
      {isMobile && (
        <div className={style.cross} onClick={handleCompanyOpen}>
          <CrossSpotlightIcon />
        </div>
      )}
      <div
        className={style.companyModal_background}
        onClick={handleCompanyOpen}
      ></div>
      <div className={style.companyModal_content}>
        <div
          className={style.companyModal_header}
          style={{
            backgroundImage: `url(${CompanyBackground})`,
          }}
        >
          <div className={style.companyModal_backgroundCover}></div>

          <div className={style.companyModal_rank}>
            <span>CES 9.7/10</span>
            <InfoLight />
          </div>

          <div className={style.companyModal_mainInfo}>
            <div className={style.companyModal_logo}>
              <MetaLogo />
            </div>
            <div className={style.companyModal_mainIfo_content}>
              <span className={style.companyModal_mainIfo_content_niche}>
                Software Development
              </span>
              <div className={style.companyModal_mainIfo_content_location}>
                <PinLightIcon />
                <span>Mento Park, CA</span>
              </div>
            </div>
          </div>

          <ul className={style.companyModal_navigation}>
            <li className={style.companyModal_navigation_item}>
              <a href="#">Connectivity</a>
            </li>
            <li className={style.companyModal_navigation_item}>
              <a href="#">Artificial Intelligence</a>
            </li>
            <li className={style.companyModal_navigation_item}>
              <a href="#">Virtual Reality</a>
            </li>
            <li className={style.companyModal_navigation_item}>
              <a href="#">Machine Learning</a>
            </li>
            <li className={style.companyModal_navigation_item}>
              <a href="#">Social Media</a>
            </li>
            <li className={style.companyModal_navigation_item}>
              <a href="#">Metaverse</a>
            </li>
            <li className={style.companyModal_navigation_item}>
              <a href="#">Mobile Connectivity</a>
            </li>
          </ul>
        </div>

        <div className={style.companyModal_dashboard}>
          {isMobile ? (
            <Swiper
              spaceBetween={30}
              grabCursor={true}
              pagination={true}
              loop={true}
              modules={[Pagination]}
              className="companyModal_dashboard_swiper"
            >
              <SwiperSlide>
                <EventsBlock />
              </SwiperSlide>
              <SwiperSlide>
                <NewsBlock />
              </SwiperSlide>
              <SwiperSlide>
                <PositionBlock />
              </SwiperSlide>
            </Swiper>
          ) : (
            <>
              <EventsBlock />

              <NewsBlock />

              <PositionBlock />
            </>
          )}

          <StatsBlock />

          <AddToChatBlock />
        </div>
      </div>
    </div>
  )
}

export default CompanyModal
